<template>
  <div class="crud_form_wrapper">
    <div class="form_title_wrapper">
      <h4>{{ $t("SIDENAV.banks.show") }}</h4>
    </div>
    <div class="col-12 text-end">
      <v-btn @click="$router.go(-1)" style="color: var(--main_theme_clr)">
        <i class="fas fa-backward"></i>
      </v-btn>
    </div>

    <div class="single_step_form_content_wrapper">
      <form @submit.prevent>
        <div class="row">
          <base-input
            col="6"
            type="text"
            :placeholder="$t('SIDENAV.banks.id')"
            v-model.trim="data.id"
            disabled
          />
          <base-input
            col="6"
            type="text"
            :placeholder="$t('SIDENAV.banks.name')"
            v-model.trim="data.name"
            disabled
          />
          <base-input
            col="6"
            type="text"
            :placeholder="$t('SIDENAV.banks.name_ar')"
            v-model.trim="data.name_ar"
            disabled
          />
          <base-input
            col="6"
            type="text"
            :placeholder="$t('SIDENAV.banks.name_en')"
            v-model.trim="data.name_en"
            disabled
          />
          <base-input
            col="6"
            type="text"
            :placeholder="$t('SIDENAV.banks.bic_code')"
            v-model.trim="data.bic_code"
            disabled
          />
          <base-input
            col="6"
            type="text"
            :placeholder="$t('SIDENAV.banks.created_at')"
            v-model.trim="data.created_at"
            disabled
          />
        </div>
      </form>
    </div>
  </div>
</template>

<script>
export default {
  name: "ShowBank",

  data() {
    return {
      data: {
        id: null,
        name: null,
        name_ar: null,
        name_en: null,
        bic_code: null,
        created_at: null,
      },
    };
  },

  methods: {
    async showBank() {
      try {
        let res = await this.$axios({
          method: "GET",
          url: `banks/${this.$route.params?.id}`,
        });
        // Response: { data: { Bank: { id, name, name_ar, name_en, bic_code, created_at } } }
        const bank = res.data.data?.Bank || res.data.data || {};
        this.data.id = bank.id ?? null;
        this.data.name = bank.name ?? null;
        this.data.name_ar = bank.name_ar ?? null;
        this.data.name_en = bank.name_en ?? null;
        this.data.bic_code = bank.bic_code ?? null;
        this.data.created_at = bank.created_at ?? null;
      } catch (error) {
        console.log(error?.response?.data?.message);
      }
    },
  },

  created() {
    this.showBank();
  },
};
</script>
